import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { EActiveFlow } from '../../types/flow';
import { ECheckEmailError, ECheckEmailStatus } from '../../types/authentication';
import { AUTHENTICATION_CHECK_EMAIL_TYPE } from '../../constants/action_types';
import { EEventType } from '../../types/events';
import { isEmailRegistered } from '../../api/isEmailRegistered';
import { changeFlow } from '../flow';
import { changeView } from '../view';
import { trackShowTwoStepPassword } from '../../utils/tracking';
import { EActiveView } from '../../types/view';
export function checkEmail() {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState, context) {
      var _getState, login, view, source, res, isRegistered;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            dispatch({
              type: AUTHENTICATION_CHECK_EMAIL_TYPE,
              status: ECheckEmailStatus.Loading
            });
            _getState = getState(), login = _getState.login, view = _getState.view, source = _getState.source;
            _context.prev = 2;
            _context.next = 5;
            return isEmailRegistered(context.httpApi, {
              email: login
            });
          case 5:
            res = _context.sent;
            if (res.statusCode === 200) {
              isRegistered = res.response.isRegistered;
              dispatch({
                type: AUTHENTICATION_CHECK_EMAIL_TYPE,
                status: ECheckEmailStatus.Succeed
              });
              context.emitter.emit(EEventType.EmailChecked, {
                isRegistered: isRegistered
              });
              if (isRegistered) {
                dispatch(changeFlow(EActiveFlow.Authentication));
                trackShowTwoStepPassword('email', source);
              } else {
                dispatch(changeView(EActiveView.Agreement, {
                  prevView: view.active,
                  prevData: view.data,
                  email: login
                }));
              }
            } else {
              dispatch({
                type: AUTHENTICATION_CHECK_EMAIL_TYPE,
                status: ECheckEmailStatus.Failed,
                errorType: ECheckEmailError.LimitReached,
                error: 'Превышен лимит попыток авторизации. Попробуйте позже'
              });
            }
            _context.next = 13;
            break;
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](2);
            context.logger.error(_context.t0, {
              domain: 'auth-widget.api.checkEmail'
            });
            dispatch({
              type: AUTHENTICATION_CHECK_EMAIL_TYPE,
              status: ECheckEmailStatus.Failed,
              errorType: ECheckEmailError.Unexpected,
              error: 'Произошла непредвиденная ошибка'
            });
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 9]]);
    }));
    return function (_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
}